var Q = require('q');
var oneValidation = require('one-validation');

function minLength(val, minLength) {
    return val.length >= minLength;
};

function exists(val) {
    return typeof val != 'undefined' && val != null && val != '';
};

module.exports = function(getData) {

    function existsInData(dataKey, value, required, formOpts) {
        var data;
        var deferred = Q.defer();
        if(formOpts && formOpts.useKindOfCar){ //If the form has set this option to true, we will skip validation and send the kindOfCar value when submitting the form
            deferred.resolve({valid: true, message: ''});
        }else{
            getData(dataKey, function(jsonString) {
                try {
                    if (typeof jsonString == 'object') {
                        data = jsonString;
                    }
                    else {
                        data = JSON.parse(jsonString);
                    }
                }
                catch (e) {
                    data = false;
                }

                var ok = true;

                if (value != '' && data.length) {
                    for(var i = 0, ii = data.length; i < ii; i++) {
                        if( value == data[i].value ) {
                            ok = true;
                            break;
                        }
                        else {
                            ok = false;
                        }
                    }
                }

                if (required && value == '') {
                    ok = false;
                }

                deferred.resolve({valid: ok, message: ''});
            });
        }           

        return deferred.promise;
    }

    return {
        personalinfo: {
            validate: function(value, required, dataKey, formOpts) {
                var ok = true;

                if (required) {
                    ok = ok && minLength(value, 1);
                }

                if (value != "") {
                    ok = ok && !!value.match(/^\d+$/);
                }

                return {valid: ok, message: ''};
            }
        },    
        configurationdata: {
            validate: function(value, required, dataKey, formOpts) {
                try{
                    if(value.length > 0){
                        JSON.parse(value);
                    }
                    
                    return {valid: true, message: ''};
                } catch(e){
                    return {valid: false, message: ''};
                }                
            }
        },
        file: {
            validate: function(value, required, dataKey, formOpts) {
                return {valid: true, message: ''};               
            }
        },
        classConfigurationUrl: {
            validate: function(value, required, dataKey, formOpts) {
                return {valid: true, message: ''};               
            }
        },
        comment: {
            validate: function(value, required, dataKey, formOpts) {
                return {valid: true, message: ''};               
            }
        },
        consent: {
            validate: function(value, required, dataKey, formOpts) {
                return {valid: true, message: ''};
            }
        },
        consentemail: {
            validate: function(value, required, dataKey, formOpts) {
                var result = {valid: true, message: ''};

                if( required || value ) {
                    if(['consentemail', 'denyemail'].indexOf(value) != -1) {
                        result.valid = true;
                    }
                    else {
                        result.valid = false;
                    }
                }

                return result;
            }
        },
        consentphone: {
            validate: function(value, required, dataKey, formOpts) {
                var result = {valid: true, message: ''};

                if( required || value ) {
                    if(['consentphone', 'denyphone'].indexOf(value) != -1) {
                        result.valid = true;
                    }
                    else {
                        result.valid = false;
                    }
                }

                return result;
            }
        },
        consentpost: {
            validate: function(value, required, dataKey, formOpts) {
                var result = {valid: true, message: ''};

                if( required || value ) {
                    if(['consentpost', 'denypost'].indexOf(value) != -1) {
                        result.valid = true;
                    }
                    else {
                        result.valid = false;
                    }
                }

                return result;
            }
        },
        subscribe: {
            validate: function(value, required, dataKey, formOpts) {
                var data;
                dataKey = dataKey || 'newsletters';
                var deferred = Q.defer();

                var newsletters = (value.length) ? value.split(',') : [];

                getData(dataKey, function(jsonString) {
                    try {
                        if (typeof jsonString == 'object') {
                            data = jsonString;
                        }
                        else {
                            data = JSON.parse(jsonString);
                        }
                    }
                    catch (e) {
                        data = false;
                    }

                    var ok = true;

                    if (required && newsletters.length == 0) {
                        ok = false;
                    }

                    if (newsletters.length > 0) {
                        var validnewsletters = [];

                        for(var i = 0, ii = data.length; i < ii; i++) {
                            validnewsletters.push(data[i].value);
                        }

                        for(var i = 0, ii = newsletters.length; i < ii; i++) {
                            ok = ok && validnewsletters.indexOf(newsletters[i]) > -1;
                        }
                    }

                    deferred.resolve({valid: ok, message: ''});
                });

                return deferred.promise;
            }
        },
        contacttime: {
            validate: function(value, required, dataKey, formOpts) {
                dataKey = dataKey || 'contacttime';
                return existsInData(dataKey, value, required, formOpts);
            }
        },
        currentbrandselect: {
            validate: function(value, required, dataKey, formOpts) {
                dataKey = dataKey || 'brands';
                return existsInData(dataKey, value, required, formOpts);
            }
        },
        brochures: {
            validate: function(value, required, dataKey, formOpts) {
                return Promise.resolve({valid: true, message: ''});
            }
        },
        iscompany: {
            validate: function(value, required, dataKey, formOpts) {
                var ok = (value == 'iscompanyaddress' || value == '');
                return {valid: ok, message: ''};
            }
        },
        retailers: {
            validate: function(value, required, dataKey, formOpts) {
                dataKey = dataKey || 'dealers';

                var data;
                var deferred = Q.defer();

                getData(dataKey, function(jsonString) {
                    try {
                        if (typeof jsonString == 'object') {
                            data = jsonString;
                        }
                        else {
                            data = JSON.parse(jsonString);
                        }
                    }
                    catch (e) {
                        data = false;
                    }

                    var ok = true;

                    if (value != '' && data && data.length) {
                        for(var i = 0, ii = data.length; i < ii; i++) {
                            if( value == data[i].outletcodeMb ) {
                                ok = true;
                                break;
                            }
                            else {
                                ok = false;
                            }
                        }
                    }

                    if (required && value == '') {
                        ok = false;
                    }

                    deferred.resolve({valid: ok, message: ''});
                });

                return deferred.promise;
            }
        },
        models: {
            validate: function(value, required, dataKey, formOpts) {                
                // dataKey = dataKey || 'models';
                // return existsInData(dataKey, value, required, formOpts);
                return Q.resolve({valid: true, message: ''});
            }
        },
        terms: {
            validate: function(value, required, dataKey, formOpts) {
                return {valid: true, message: ''};
            }
        },
        checkbox: {
            validate: function(value, required, dataKey, formOpts) {
                return {valid: true, message: ''};
            }
        },
        dropdown: {
            validate: function(value, required, dataKey, formOpts) {
                var ok = true;

                if (required) {
                    ok = ok && minLength(value, 1);
                }

                return {valid: ok, message: ''};
            }
        },
        radiobutton: {
            validate: function(value, required, dataKey, formOpts) {
                return {valid: true, message: ''};
            }
        },
        input: {
            validate: function(value, required, dataKey, formOpts) {
                var ok = true;

                if (required) {
                    ok = minLength(value, 1);
                }

                return {valid: ok, message: ''};
            }
        },
        firstname: {
            validate: function(value, required, dataKey, formOpts) {

                var ok = true;
                var errorType = '';

                if (required) {
                    ok = ok && value != '';

                    if( !ok ) {
                        errorType = 'required';
                    }
                }

                if (value != '') {
                    ok = ok && !value.match(/\d/g) && minLength(value, 2);

                    if( !ok ) {
                        errorType = 'min-length';
                    }
                }

                return {valid: ok, message: '', errorType: errorType};
            }
        },
        lastname: {
            validate: function(value, required, dataKey, formOpts) {
                var ok = true;
                var errorType = '';

                if (required) {
                    ok = ok && minLength(value, 1);

                    if( !ok ) {
                        errorType = 'required';
                    }
                }

                if (value != '') {
                    ok = ok && !value.match(/\d/g) && minLength(value, 2);

                    if( !ok ) {
                        errorType = 'min-length';
                    }
                }

                return {valid: ok, message: '', errorType: errorType};
            }
        },
        email: {
            validate: function(value, required, dataKey, formOpts) {
                var ok = true;
                var errorType = '';

                if (required) {
                    ok = ok && minLength(value, 5);

                    if( !ok ) {
                        errorType = 'required';
                    }
                }

                // is the value ok? (valid)
                if (value != '') {
                    var regExp = oneValidation['email'];
                    ok = ok && regExp.test(value);

                    if( !ok ) {
                        errorType = 'invalid';
                    }
                }

                return {valid: ok, message: '', errorType: errorType};
            }
        },
        zipcode: {
            validate: function(value, required, dataKey, formOpts) {
                var ok = true;
                var errorType = '';

                if (required) {
                    ok = ok && minLength(value, 1);

                    if( !ok ) {
                        errorType = 'required';
                    }
                }

                if (value != "") {
                    ok = ok && (!!value.match(/^[0-9]{3}(\s|)[0-9]{2}$/) || !!value.match(/^[0-9]{4}$/));

                    if( !ok ) {
                        errorType = 'invalid';
                    }
                }

                return {valid: ok, message: '', errorType: errorType};
            }
        },
        pagebreak: {
            validate: function(value, required, dataKey, formOpts) {
            }
        },
        submit: {
            validate: function(recaptchaValue, required, dataKey, formOpts) {
                var ok = recaptchaValue && recaptchaValue.length > 0 ? true : false;
                var errorType = '';
                if (required && ok === false) {
                    errorType = 'no-captcha';
                }
                return {valid: ok, message: '', errorType: errorType};
            }
        },
        district: {
            validate: function(value, required, dataKey, formOpts) {
                var ok = true;

                if (required) {
                    ok = ok && minLength(value, 1);
                }

                if (value != '') {
                    ok = ok && !value.match(/\d/g);
                }

                return {valid: ok, message: ''};
            }
        },
        regnr: {
            validate: function(value, required, dataKey, formOpts) {
                var ok = true;

                if (required) {
                    ok = ok && minLength(value, 5);
                }

                if (value != "") {
                    ok = ok && !!value.match(/^[A-Za-z]{2,3}[0-9]{2,5}(|[A-Za-z])$/);
                }

                return {valid: ok, message: ''};
            }
        },
        commisionnumber: {
            validate: function(value, required, dataKey, formOpts) {
                var ok = true;

                if (required) {
                    ok = ok && value.length === 10;
                }

                return {valid: ok, message: ''};
            }
        },
        address: {
            validate: function(value, required, dataKey, formOpts) {
                var ok = true;

                if (required) {
                    ok = ok && minLength(value, 1);
                }

                return {valid: ok, message: ''};
            }
        },
        co: {
            validate: function(value, required, dataKey, formOpts) {
                var ok = true;

                if (required) {
                    ok = ok && minLength(value, 1);
                }

                return {valid: ok, message: ''};
            }
        },
        company: {
            validate: function(value, required, dataKey, formOpts) {
                var ok = true;

                if (required) {
                    ok = ok && minLength(value, 1);
                }

                return {valid: ok, message: ''};
            }
        },
        phone: {
            validate: function(value, required, dataKey, formOpts) {
                var ok = true;

                if (required) {
                    ok = ok && minLength(value, 1);
                }

                if (value != "") {
                    ok = ok && !!value.match(/^[0-9\+\(\)\-\s]{1,20}$/);
                }

                return {valid: ok, message: ''};
            }
        },
        message: {
            validate: function(value, required, dataKey, formOpts) {
                var ok = true;
                var errorType = '';
                if(formOpts && Array.isArray(formOpts)){ // formOpts is our regexp
                    var maxLength = formOpts[1]; // Match (number) 
                    if(maxLength){
                        maxLength = maxLength.replace(/[\(\)]/g,"");
                        ok = ok && value.length <= maxLength;
                        if( !ok ) {
                            errorType = 'max-num-chars';
                        }
                    }
                }
                if (ok && required) {
                    ok = ok && minLength(value, 1);
                    if( !ok ) {
                        errorType = 'required';
                    }
                }

                return {valid: ok, message: '', errorType: errorType};
            }
        },
        mobile: {
            validate: function(value, required, dataKey, formOpts) {
                var ok = true;
                var errorType = '';

                if (required) {
                    ok = ok && minLength(value, 1);

                    if( !ok ) {
                        errorType = 'required';
                    }
                }

                if (value != '') {
                    ok = ok && !!value.match(/^[0-9\+\(\)\-\s]{1,20}$/);

                    if( !ok ) {
                        errorType = 'invalid';
                    }
                }

                return {valid: ok, message: '', errorType: errorType};
            }
        },
        testvehicleslots: {
            validate: function(value, required, dataKey, formOpts) {
                return {valid: true, message: ''};
            }
        },
 
    };
};



// WEBPACK FOOTER //
// ./validation.js